import { create } from "zustand";

type Action = {
    title?: string;
    callback?(...args: any[]): Promise<void> | void;
};

interface InitialState {
    visible: boolean;
    title: string;
    message?: string;
    actions?: {
        cancel?: Action;
        confirm?: Action;
    };
}

interface Actions {
    open(config: Omit<InitialState, "visible">): void;
    close(): void;
}

const initialState: InitialState = {
    visible: false,
    title: "",
    message: "",
    actions: {},
};

const useAlert = create<InitialState & Actions>(set => ({
    ...initialState,
    open: config => set({ visible: true, ...config }),
    close: () => set(initialState),
}));

export default useAlert;
